var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBscShort(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 53,
    viewBox: "0 0 46 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.6716 44.0111V49.9546L22.5 53L17.4755 49.9546V44.0111L22.5 47.0565L27.6716 44.0111ZM0 23.4546L5.02451 26.5V36.6923L13.6765 41.8744V47.8179L0 39.7377V23.4546ZM44.9755 23.4546V39.7623L31.152 47.8424V41.899L39.8039 36.7169V26.5246L44.9755 23.4546ZM31.152 15.3744L36.3235 18.4198V24.3633L27.6716 29.5454V39.9096L22.6471 42.955L17.6226 39.9096V29.5454L8.65196 24.3633V18.4198L13.8235 15.3744L22.4755 20.5565L31.152 15.3744ZM8.65196 28.6367L13.6765 31.6821V37.6256L8.65196 34.5802V28.6367ZM36.3235 28.6367V34.5802L31.299 37.6256V31.6821L36.3235 28.6367ZM5.02451 10.1923L10.1961 13.2377L5.02451 16.3077V22.2512L0 19.1812V13.2377L5.02451 10.1923ZM39.9755 10.1923L45.1471 13.2377V19.1812L39.9755 22.2266V16.3077L34.951 13.2623L39.9755 10.1923ZM22.5 10.1923L27.6716 13.2377L22.5 16.3077L17.4755 13.2377L22.5 10.1923ZM22.5 0L36.3235 8.08017L31.299 11.1256L22.6471 5.94347L13.8235 11.1256L8.82353 8.08017L22.5 0Z",
    fill: "#F3BA2F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBscShort);
export default __webpack_public_path__ + "static/media/bsc-short.780e187d7d8e669ee5ac5a3384257ea8.svg";
export { ForwardRef as ReactComponent };